import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';

import Divider from 'shared/components/Divider';

import {
  getInfluencerFullName,
  getInfluencerOccupation
} from 'shared/utils/influencer';
import { getImageStyle } from 'shared/utils/getImageStyle';

import styles from './styles.module.scss';

const UserBox = ({ user, openAction, notificationAlertCount }) => {
  const avatarStyles = getImageStyle({
    image: _.get(user, 'profile.avatar'),
    thumbnails: _.get(user, 'profile.thumbnails'),
    height: 70,
    width: 70,
    minHeight: 70,
    minWidth: 70
  });

  return (
    <React.Fragment>
      <div className={styles.userBox} onClick={openAction}>
        <div className={styles.userAvatar} style={avatarStyles} />

        <div className={styles.data}>
          <div className={styles.name}>{getInfluencerFullName(user)}</div>
          <div className={styles.occupation}>
            {getInfluencerOccupation(user, ', ')}
          </div>
          <div className={styles.stats}>
            <div className={styles.stat}>
              {user.contribution_count} Contributions
            </div>
            <div className={styles.stat}>
              {user.connection_count} Connections
            </div>
          </div>
        </div>
        <div className={classnames('material-icons', styles.arrow)}>
          keyboard_arrow_right
        </div>
      </div>
      <Divider />
    </React.Fragment>
  );
};

export default UserBox;
